import { memo } from "react"

const OrderHistory = ({ orderHistory }) => {

    return (
        <table className='table table-hover table-bordered table-striped'>
            <thead>
                <tr>
                    <th className='text-center'>
                        <div className='font-size2 color-text text-capitalize py-2'>Date</div>
                    </th>
                    <th className='text-center'>
                        <div className='font-size2 color-text text-capitalize py-2'>Amount</div>
                    </th>
                    <th className='text-center'>
                        <div className='font-size2 color-text text-capitalize py-2'>Status</div>
                    </th>
                    <th className='text-end pe-5'>
                        <div className='font-size2 color-text text-capitalize py-2'>Units</div>
                    </th>
                </tr>
            </thead>
            <tbody>
                {orderHistory?.length &&
                    orderHistory.map((item, id) =>
                        < tr key={id} >
                            <td className='text-center'>
                                <div className='font-regular font-size2 color-text text-capitalize py-1'>{item?.date}</div>
                            </td>
                            <td className='text-center'>
                                <div className='font-regular font-size2 color-text text-capitalize py-1 text-truncate'>{item?.amount}</div>
                            </td>
                            <td className='text-center'>
                                <div className='font-regular font-size2 color-text text-capitalize py-1 text-'>{item?.status}</div>
                            </td>
                            <td className='text-end pe-5'>
                                <div className='font-regular font-size2 color-text text-capitalize py-1'>{item?.units}</div>
                            </td>
                        </tr>
                    )
                }
            </tbody>
        </table>
    )
}
export default memo(OrderHistory)